// import Home1 from '../assets/Home1.jpg'
import Home1 from '../assets/9704-ecommerce.gif'
// import Home2 from '../assets/Home2.jpg'
import Home2 from '../assets/53902-online-shopping-and-delivery.gif'
// import Home3 from '../assets/Home3.jpg'
import Home3 from '../assets/77169-buy-and-sell-online.gif'

export const slideData=[
    {
        id:1,
        img:Home1,
        title:"Diwali Sale",
        desc:"Don't wait for your turn in long queues, shop at your home.",
        bg:"f5fafd",
    },
    {
        id:2,
        img:Home3,
        title:"Flexible Delivery",
        desc:"Choose your delivery options for every products.",
        bg:"fcf1ed",
    },
    {
        id:3,
        img:Home2,
        title:"Multiple Payment Options",
        desc:"Choose whether Pay online or Pay after delivery",
        bg:"fbf0f4",
    } 
]

export const popularProducts = [
    {
      id:1,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:2,
      img:"https://cdn.shopify.com/s/files/1/0101/4832/products/Angela_Natural_Tee.png?v=1606780388",
    },
    {
      id:3,
      img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
      id:4,
      img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
    },
    {
      id:5,
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id:6,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
    },
    {
      id:7,
      img:"https://m.media-amazon.com/images/I/81qlnA0rJEL._UY606_.jpg",
    },
    {
      id:8,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
  ]